import { Injectable, Type } from "@angular/core";
import { Observable, ReplaySubject, Subject, take } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ActivityLogService {

  constructor() { }

  private triggerContainerLog$ = new Subject<{ containerId: string }>;

  triggerContainerActivityLog(containerId: string) {
    console.log('triggering', containerId);
    this.triggerContainerLog$.next({ containerId });
  }

  getContainerLogTrigger(): Observable<{ containerId: string }> {
    return this.triggerContainerLog$.asObservable();
  }
}
